import Modal from 'components/Modal';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import StaffsSelect from './components/StaffsSelect';
import { ConfigProvider } from 'antd';

export type SelectStaffsModalRef = {
    open: (data: Partial<{ staffs: IStaffItemData[], activeStaffIds: string[] }>) => Promise<IStaffItemData[] | null>;
}

export const useSelectStaffsModalRef = () => useRef<SelectStaffsModalRef>(null);
const SelectStaffsModal = forwardRef<SelectStaffsModalRef>((_, ref) => {
    const [open, setOpen] = useState(false);
    const [staffs, setStaffs] = useState<IStaffItemData[]>([]);
    const [activeStaffIds, setActiveStaffIds] = useState<string[]>([]);

    const callBackRef = useRef<((data: IStaffItemData[] | null) => void) | null>(null);

    const onOpen = (data: Partial<{ staffs: IStaffItemData[], activeStaffIds: string[] }>) => {
        setOpen(true);
        setStaffs(data.staffs || []);
        setActiveStaffIds(data.activeStaffIds || []);
    };

    const onClose = () => {
        setOpen(false);
        setStaffs([]);
        setActiveStaffIds([]);
        callBackRef.current?.(null);
    };

    useImperativeHandle(ref, () => ({
        open: async (data: Partial<{ staffs: IStaffItemData[], activeStaffIds: string[] }>) => {
            onOpen(data);
            return new Promise<IStaffItemData[] | null>((resolve) => {
                callBackRef.current = resolve;
            });
        }
    }));

    const onSubmit = () => {
        setOpen(false);
        const selectedStaffs = staffs.filter((o) => activeStaffIds.includes(o.id));
        console.log('selectedStaffs', selectedStaffs);
        callBackRef.current?.(selectedStaffs);
    };

    if (!open) return null;
    return (
        <Modal
            v2
            visible={!!open}
            modalTitle='SELECT STAFF'
            noneBodyStyle
            onClose={onClose}
            onSubmit={onSubmit}
            width={1600}
            okTitle='OK'
        >
            <ConfigProvider
                theme={{
                    components: {
                        Checkbox: {
                            colorPrimaryHover: '#2D6772',
                            colorPrimary: '#2D6772',
                            borderRadiusSM: 3,
                            controlInteractiveSize: 32,
                        },
                    },
                }}
            >
                <StaffsSelect staffs={staffs} value={activeStaffIds} onChange={setActiveStaffIds} />
            </ConfigProvider>
        </Modal>
    );
});

SelectStaffsModal.displayName = 'SelectStaffsModal';
export default SelectStaffsModal;
